import DashboardLayout from '@/views/Layout/DashboardLayout.vue';

const DistributorsList = () => import(/* webpackChunkName: "distributors" */ '@/views/Distributors/List.vue');
const DistributorCreate = () => import(/* webpackChunkName: "distributors" */ '@/views/Distributors/Create.vue');
const DistributorShow = () => import(/* webpackChunkName: "distributors" */ '@/views/Distributors/Show.vue');
const DistributorEdit = () => import(/* webpackChunkName: "distributors" */ '@/views/Distributors/Edit.vue');

const VisitCreate = () => import(/* webpackChunkName: "distributors-visits" */ '@/views/Visits/Create.vue');

const DocumentsList = () => import(/* webpackChunkName: "distributors-documents" */ '@/views/Documents/List.vue');
const ContactCreate = () => import(/* webpackChunkName: "distributors-contacts" */ '@/views/Contacts/Create.vue');

const DistributorProjectionList = () =>
  import(/* webpackChunkName: "distributors-projections" */ '@/views/Projection/DistributorList.vue');
const DistributorOrderList = () =>
  import(/* webpackChunkName: "distributors-orders" */ '@/views/Orders/DistributorList.vue');

let distributorsPages = {
  path: '/distributors',
  redirect: '/distributors',
  component: DashboardLayout,
  name: 'Distributors',
  meta: {
    title: 'Distribuidores',
    auth: true,
  },
  children: [
    {
      path: '',
      name: 'DistributorsList',
      meta: {
        title: 'Listado',
        auth: ['distributors.index'],
      },
      component: DistributorsList,
    },
    {
      path: 'create',
      name: 'DistributorCreate',
      meta: {
        title: 'Nuevo',
        auth: ['distributors.store'],
      },
      component: DistributorCreate,
    },
    {
      path: ':id',
      name: 'DistributorShow',
      meta: {
        title: 'Detalle',
        auth: ['distributors.show'],
      },
      component: DistributorShow,
    },
    {
      path: ':id/edit',
      name: 'DistributorEdit',
      meta: {
        title: 'Editar',
        auth: ['distributors.update'],
      },
      component: DistributorEdit,
    },
    {
      path: ':id/visits/create',
      name: 'DistributorCreateVisit',
      meta: {
        title: 'Nueva Visita',
        typeToShow: 'Distributor',
        resource: 'distributors',
        auth: ['visits.store'],
      },
      component: VisitCreate,
    },
    {
      path: ':id/documents',
      name: 'DistributorDocuments',
      meta: {
        title: 'Listado',
        subtitle: 'Documentos del distribuidor',
        type: '',
        entity: 'distributors',
        auth: ['distributors.show', 'documents.index'],
      },
      component: DocumentsList,
    },
    {
      path: ':id/contacts/create',
      name: 'DistributorCreateContact',
      meta: {
        title: 'Nuevo',
        entity: 'distributors',
        auth: ['contacts.store'],
      },
      component: ContactCreate,
    },
    {
      path: ':id/projections',
      name: 'DistributorProjectionList',
      meta: {
        title: 'Proyecciones del distribuidor',
        entity: 'distributors',
        auth: ['projections.index'],
      },
      component: DistributorProjectionList,
    },
    {
      path: ':id/orders',
      name: 'DistributorOrderList',
      meta: {
        title: 'Órdenes del distribuidor',
        entity: 'distributors',
        auth: ['orders.index'],
      },
      component: DistributorOrderList,
    },
  ],
};

export default distributorsPages;
